import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "imaginary_cart";
const ZONE_KEY = "imaginary_ship_zone";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);
  const [shipZone, setShipZone] = useState(() => {
    try {
      return localStorage.getItem(ZONE_KEY) || "FR";
    } catch {
      return "FR";
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    try {
      localStorage.setItem(ZONE_KEY, shipZone);
    } catch {}
  }, [shipZone]);

  const lineKey = (i) =>
    `${i.product_id}-${i.color}-${i.size}-${i.framing || "unframed"}-${i.frame_color || ""}-${i.tier || ""}-${i.custom_word || ""}-${i.bundle_items ? i.bundle_items.map((b) => b.product_id + b.color).join("+") : ""}`;

  const addItem = (item) => {
    setItems((prev) => {
      const k = lineKey(item);
      const found = prev.find((p) => lineKey(p) === k);
      if (found) {
        return prev.map((p) =>
          lineKey(p) === k ? { ...p, quantity: p.quantity + item.quantity } : p
        );
      }
      return [...prev, item];
    });
    setIsOpen(true);
  };

  const removeItem = (k) => setItems((prev) => prev.filter((p) => lineKey(p) !== k));
  const setQuantity = (k, q) =>
    setItems((prev) =>
      prev.map((p) => (lineKey(p) === k ? { ...p, quantity: Math.max(1, q) } : p))
    );
  const clear = () => setItems([]);

  const openCart = () => setIsOpen(true);
  const closeCart = () => setIsOpen(false);

  const count = items.reduce((n, i) => n + i.quantity, 0);
  const total = items.reduce((n, i) => n + i.unit_price * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{
        items, addItem, removeItem, setQuantity, clear, count, total, lineKey,
        isOpen, openCart, closeCart, shipZone, setShipZone,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
